import { useEffect, useState } from 'react';
import { api } from '../api';
import ExportButton from '../components/ExportButton';

export default function Finance() {
  const [summary, setSummary] = useState<any>(null);
  const [txns, setTxns] = useState<any[]>([]);
  const [depts, setDepts] = useState<any[]>([]);
  const [form, setForm] = useState<any>({
    type: 'income',
    category: '',
    amount: '',
    department_id: '',
    remark: '',
    occurred_at: '',
  });

  const load = () => {
    api('/finance/summary').then(setSummary);
    api('/finance/transactions').then(setTxns);
    api('/departments').then(setDepts);
  };
  useEffect(load, []);

  const submit = async () => {
    if (!(Number(form.amount) > 0)) return alert('金额必须大于 0');
    await api('/finance/transactions', {
      method: 'POST',
      body: JSON.stringify({ ...form, amount: Number(form.amount), department_id: form.department_id || null }),
    });
    setForm({ type: 'income', category: '', amount: '', department_id: '', remark: '', occurred_at: '' });
    load();
  };

  const cards: any[] = [
    ['总收入', summary?.totalIncome, 'text-emerald-600'],
    ['总支出', summary?.totalExpense, 'text-rose-600'],
    ['净利润', summary?.profit, 'text-brand-600'],
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-2xl font-bold">财务与销量</h2>
        <ExportButton
          filename="财务流水"
          fetchData={() => api('/finance/transactions')}
          columns={[
            { header: '日期', key: 'occurred_at' },
            { header: '类型', key: 'type', format: (r) => (r.type === 'income' ? '收入' : '支出') },
            { header: '类别', key: 'category' },
            { header: '部门', key: 'department_name' },
            { header: '金额', key: 'amount' },
            { header: '备注', key: 'remark' },
          ]}
        />
      </div>
      {summary && (
        <div className="grid grid-cols-3 gap-4">
          {cards.map(([l, v, c]) => (
            <div key={l} className="bg-white rounded-xl shadow p-5">
              <div className="text-slate-500 text-sm">{l}</div>
              <div className={`text-2xl font-bold ${c}`}>¥{Number(v || 0).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
      <div className="bg-white rounded-xl shadow p-4 grid grid-cols-6 gap-2 items-end">
        <select className="border rounded px-2 py-1" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
          <option value="income">收入</option>
          <option value="expense">支出</option>
        </select>
        <input className="border rounded px-2 py-1" placeholder="类别" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} />
        <input type="number" className="border rounded px-2 py-1" placeholder="金额" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} />
        <select className="border rounded px-2 py-1" value={form.department_id} onChange={(e) => setForm({ ...form, department_id: e.target.value })}>
          <option value="">选择部门</option>
          {depts.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        <input className="border rounded px-2 py-1" placeholder="备注" value={form.remark} onChange={(e) => setForm({ ...form, remark: e.target.value })} />
        <button onClick={submit} className="bg-brand-600 text-white rounded px-3 py-1 hover:bg-brand-700">
          记一笔
        </button>
      </div>
      <table className="w-full bg-white rounded-xl shadow text-sm">
        <thead>
          <tr className="text-slate-500 text-left">
            <th className="p-3">日期</th>
            <th>类型</th>
            <th>类别</th>
            <th>部门</th>
            <th>金额</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody>
          {txns.map((t) => (
            <tr key={t.id} className="border-t">
              <td className="p-3">{t.occurred_at}</td>
              <td>{t.type === 'income' ? '收入' : '支出'}</td>
              <td>{t.category}</td>
              <td>{t.department_name || '—'}</td>
              <td className={t.type === 'income' ? 'text-emerald-600' : 'text-rose-600'}>{t.amount}</td>
              <td>{t.remark}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
